import { useEffect, useState } from 'react';

import { excludedGrandParentIds, communitiesId } from 'core/constants';
import { useContextMatchParams } from 'contexts/matchParams';
import { makeRequest } from 'utils';
import { PATH, TYPES } from '../../envs/core';
import { useGetMatchPartiesPath } from './useGetMatchPartiesPath';

window.cacheKey = window.cacheKey || {};
window.callStack = window.callStack || [];

const regions = communitiesId.filter(
  regionId => !excludedGrandParentIds.includes(regionId)
);

const empty = [];

const useMatchParties = year => {
  const { matchParams } = useContextMatchParams();

  const { allMap, type } = matchParams;

  const isAllMap = Boolean(Number(allMap));

  const dataPath = useGetMatchPartiesPath(year);

  const [restData, setRestData] = useState(empty);

  useEffect(() => {
    if (type === TYPES.REGIONAL && isAllMap) {
      Promise.all(
        regions.map(region => {
          const path = dataPath.includes(PATH)
            ? `${dataPath}${region}`
            : `${PATH}${dataPath}${region}`;
          return makeRequest(path);
        })
      ).then(res => {
        const result = regions.map((region, index) => {
          const regionData = res[index];
          if (regionData) {
            return regionData.map(item => ({
              ...item,
              region
            }));
          }
          return [];
        });
        setRestData(result.flat(1).filter(a => a));
      });
    } else {
      const path = dataPath.includes(PATH) ? dataPath : `${PATH}${dataPath}`;
      const region = regions.find(r => dataPath.includes(r));
      if (!region && type === TYPES.REGIONAL) {
        return setRestData([]);
      }

      makeRequest(path).then(res => {
        setRestData(res);
      });
    }
    return () => {};
  }, [dataPath, isAllMap, type]);

  return restData;
};

export default useMatchParties;
